module.exports = __webpack_public_path__ + "static/img/MANCHESTER_OAK.683cc03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/MANCHESTER_OAK.jpg
// module id = F7O+
// module chunks = 0